import { render } from "./SkelLabel.vue?vue&type=template&id=1dba8f14&scoped=true"
import script from "./SkelLabel.vue?vue&type=script&lang=js"
export * from "./SkelLabel.vue?vue&type=script&lang=js"

import "./SkelLabel.vue?vue&type=style&index=0&id=1dba8f14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dba8f14"]])

export default __exports__